import React from 'react';
import { Tabs, Typography, Card } from 'antd';
import { useParams } from 'react-router-dom';
import InspectionAppointmentForm from './Form';
import InspectionTaskList from '../../inspection-tasks/views/List';
export default function InspectionAppointmentDetail(){
  const { id } = useParams();
  const referenceId = Number(id);
  const items = [
    { key: 'tab0', label: 'Randevu Bilgileri', children: <InspectionAppointmentForm id={Number(id)} onSuccess={() => {}} /> },
    { key: 'tab1', label: 'Denetim Görevleri', children: <InspectionTaskList referenceId={referenceId} /> }
  ];
  return (
    <Card className='br-30px' title={<Typography.Title level={4} style={{ margin: 0 }}>Denetim Randevusu Detayı</Typography.Title>}>
      <Tabs items={items} />
    </Card>
  );
}
